const Image = ({ src, style = {}, key = null, onClick = null, defer = true, className = null, alt = "Icon", ...props }) => {
  return (
    <>
      {defer ? (
        <img src={src} style={style} key={key} onClick={onClick} className={className} alt={alt} loading="lazy" />
      ) : (
        <img src={src} style={style} key={key} onClick={onClick} className={className} alt={alt} />
      )}
    </>
  )
}
export default Image
